// extracted by mini-css-extract-plugin
export default {"primaryButton":"primaryButton__1aFis","primaryButtonInverse":"primaryButtonInverse__333hm","buttonContentWrapper":"buttonContentWrapper__3vp1X"};
    if(module.hot) {
      // 1764953342245
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  